/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS and PBS keep well refrigerated; add Tween fresh if storing long-term. Blocking buffers with milk or BSA should be made fresh.`)
};

const es_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS y PBS se conservan bien refrigerados; añade Tween en el momento si los almacenas a largo plazo. Los buffers de bloqueo con leche o BSA deben prepararse frescos.`)
};

const de_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS und PBS halten sich gekühlt gut; Tween bei längerer Lagerung erst frisch zugeben. Blockierpuffer mit Milch oder BSA sollten frisch angesetzt werden.`)
};

const nl_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS en PBS blijven goed gekoeld houdbaar; voeg bij langdurige opslag vers Tween toe. Blokkeerbuffers met melk of BSA kunt u het beste vers maken.`)
};

const fr_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le TBS et le PBS se conservent bien au réfrigérateur ; ajoutez le Tween frais en cas de conservation longue. Les tampons de blocage au lait ou à la BSA doivent être préparés frais.`)
};

const it_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS e PBS si conservano bene in frigorifero; aggiungi il Tween fresco se li conservi a lungo. I buffer di blocco con latte o BSA vanno preparati freschi.`)
};

const pt_br2_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS e PBS se conservam bem sob refrigeração; adicione o Tween na hora se for armazenar por longo prazo. Tampões de bloqueio com leite ou BSA devem ser preparados na hora.`)
};

const pt_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS e PBS conservam-se bem no frigorífico; adicione o Tween de fresco se armazenar por longos períodos. Os tampões de bloqueio com leite ou BSA devem ser preparados de fresco.`)
};

const ja_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBSとPBSは冷蔵保存でよく持ちます。長期保存する場合はTweenを使用直前に加えてください。ミルクまたはBSAを含むブロッキングバッファーは使用直前に調製してください。`)
};

const zh_buf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TBS 和 PBS 冷藏可较长时间保存；若需长期存放，Tween 应现用现加。含脱脂奶或 BSA 的封闭液应现配现用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_a4", locale)
	if (locale === "en") return en_buf_faq_a4(inputs)
	if (locale === "es") return es_buf_faq_a4(inputs)
	if (locale === "de") return de_buf_faq_a4(inputs)
	if (locale === "nl") return nl_buf_faq_a4(inputs)
	if (locale === "fr") return fr_buf_faq_a4(inputs)
	if (locale === "it") return it_buf_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_a4(inputs)
	if (locale === "pt") return pt_buf_faq_a4(inputs)
	if (locale === "ja") return ja_buf_faq_a4(inputs)
	return zh_buf_faq_a4(inputs)
};